import React from 'react';
import * as S from './SuccessRegistered.styles';

import IconSelector from '@ibibo/icon-selector';

const SuccessRegistered = () => {

    return (
        <S.SuccessMsgWrap>
            <S.CheckCircleWrap>
                <IconSelector iconKey='tickmarkwhite' props={{width:"3rem", height:"3rem"}} />
            </S.CheckCircleWrap>
            <S.SuccessMsgText>Thank You! Your account has been created successfully</S.SuccessMsgText>
        </S.SuccessMsgWrap>
    );
}

export default SuccessRegistered;
